<template>
    <section class="providersIndexSection">
        <div
            v-if="$route.name === 'admin'"
            class="affiliatedWrapper"
        >
            <template v-for="(item, index) in guidesAdmin">
                <v-card
                    v-if="$cookies.get('user_type') === 'admin'"
                    :key="index"
                    class="card"
                    raised
                    @click="$router.push(item.route)"
                >
                    <v-card-text>
                        <v-card-title class="text--primary d-flex flex-column">
                            <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                                <v-icon
                                    size="50"
                                    class="white--text"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-avatar>
                            <div class="text-wrap" style="word-break: normal; text-align: center;">
                                {{ item.text }}
                            </div>
                        </v-card-title>
                    </v-card-text>
                </v-card>
            </template>
            <template v-for="(item, index) in guidesAcu">
                <v-card
                    v-if="$cookies.get('user_type') === 'admin' || $cookies.get('user_type') === 'acu'"
                    :key="index"
                    class="card"
                    raised
                    @click="$router.push(item.route)"
                >
                    <v-card-text>
                        <v-card-title class="text--primary d-flex flex-column">
                            <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                                <v-icon
                                    size="50"
                                    class="white--text"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-avatar>
                            <div class="text-wrap" style="word-break: normal; text-align: center;">
                                {{ item.text }}
                            </div>
                        </v-card-title>
                    </v-card-text>
                </v-card>
            </template>
            <template v-for="(item, index) in guidesClaims">
                <v-card
                    v-if="$cookies.get('user_type') === 'admin' || $cookies.get('user_type') === 'claims'"
                    :key="index"
                    class="card"
                    raised
                    @click="$router.push(item.route)"
                >
                    <v-card-text>
                        <v-card-title class="text--primary d-flex flex-column">
                            <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                                <v-icon
                                    size="50"
                                    class="white--text"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-avatar>
                            <div class="text-wrap" style="word-break: normal; text-align: center;">
                                {{ item.text }}
                            </div>
                        </v-card-title>
                    </v-card-text>
                </v-card>
            </template>
        </div>
        <NavBar v-else />
    </section>
</template>

<script>
import NavBar from '../Navbar.vue'
import {
    mdiInformationVariant,
    mdiAccountGroup,
    mdiTools,
    mdiAccountHeart,
    mdiBook
} from '@mdi/js'
export default {
    components: {
        NavBar
    },
    data: ()=>({
        guidesAdmin: [
            {
                icon: mdiInformationVariant,
                text: 'Providers',
                route: '/admin/providers'
            },
            {
                icon: mdiAccountGroup,
                text: 'Members',
                route: '/admin/members'
            },
            {
                icon: mdiTools,
                text: 'Util',
                route: '/admin/util'
            }
        ],
        guidesAcu: [
            {
                icon: mdiAccountHeart,
                text: 'ACU',
                route: '/admin/acu'
            }
        ],
        guidesClaims: [
            {
                icon: mdiBook,
                text: 'Ledgers',
                route: '/admin/claims/ledgers'
            }
        ]
    }),
    created() {
    // this.$router.push({name: 'providersMenu'})
    }
}
</script>

<style scoped>
section {
    width: 100%;
    height: 100%;
    background-image: url("./../../assets/dashboardBG.webp");
    background-size: cover;
    background-position: center;
}
.affiliatedWrapper {
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(180deg, #b4ff9a 0%, #02cf9f 100%);
}
</style>
